import Vue from 'vue'
import VueRouter from 'vue-router'
import routerConfig from '@/config/router'

Vue.use(VueRouter)
const router = new VueRouter({
  mode: routerConfig.mode,
  base: '/',
  routes: [
    {
      path: '/',
      name: 'Index',
      component: () => import('@/pages/index/views/Index.vue'),
    },

    {
      path: '/:shareToken',
      name: 'Index',
      component: () => import('@/pages/index/views/Index.vue'),
    },
    {
      path: '*',
      name: '404 Not Found',
      beforeEnter: () => {
        window.location.href = '/'
      },
    },
  ],
})
router.beforeEach(async (to, from, next) => {
  if (to.path === '*') {
    // window.location.href = '/'
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/pages/index/router/index.js